export default __webpack_public_path__ + "static/media/googlecolab.8c39636a.svg";